export const elementEventListener = (event) => {
    event.currentTarget[event.type](event);
};
